export * from './auth'
export * from './busers'
export * from './businesses'
export * from './competencies'
export * from './coupons'
export * from './feedback'
export * from './graphs'
export * from './payments'
export * from './preferences'
export * from './prospects'
export * from './questions'
export * from './skills'
export * from './tags'
export * from './templates'
export * from './tests'
export * from './users'
export * from './vouchers'

const set_path = (path) => {
  return {
    type: "SET_PATH",
    payload: path
  }
}

const toggle_collapse = () => {
  return {
    type: "SET_COLLAPSE"
  }
}

const toggle_mobile = () => {
  return {
    type: "SHOW_MOBILE"
  }
}

const reset_progress = () => {
  return {
    type: "RESET_PROGRESS"
  }
}

export {
  set_path,
  toggle_mobile,
  toggle_collapse,
  reset_progress
}



// WEBPACK FOOTER //
// ./src/js/actions/index.js